import dayjs from "dayjs";

export const getAge = (dob) => {
    return dayjs().diff(dayjs(dob), "year");
};
